import axios from '@/service/index'
// WR-346：initConfig 与 initLoginUser **都刻意不自动重试**（`retry: 0` 显式写出，不是忘了配）。
// 原因是白屏/半坏页面的等待窗口：两者都在首屏关键路径上，自动重试会把窗口从单次超时 15s
// 拉到 ≈48s（15s + 1s 退避 + 15s + 2s 退避 + 15s），真机 S0/S1 两档均实测确认，
// 用户看到的仍是"很久的白屏"，不是恢复。恢复路径统一由错误提示区的重试按钮（整页重载）承担。
// 这不是"默认值共用"——是同一个结论作用于两个接口；谁想给首屏接口加 retry 前先读这段 [Claude Code]
// timeoutTips 也去掉：超时提示统一由守卫的提示区承担（toast 会自己消失、提示区不会，
// 两者语义重叠、位置不同，观感不一致；少一处文案维护点）。timeoutTips 机制本身保留在
// src/service/index.js，其它接口仍可用 [Claude Code]
const INIT_REQUEST_NO_RETRY_POLICY = {
  retry: 0
}

export const initConfig = data => {
  return axios({
    url: '/ccp/tvucc-user/base/initConfig',
    method: 'GET',
    params: data,
    ...INIT_REQUEST_NO_RETRY_POLICY
  })
}

export const userInfo = data => {
  return axios({
    url: '/ccp/initLoginUser',
    method: 'GET',
    headers: {
      pageMark: data
    },
    ...INIT_REQUEST_NO_RETRY_POLICY
  })
}
